'use client';

import s from 'Workadabra/app/[lang]/home/sections/services/styles.module.css';
import {
  rdServicesPaint,
  rdServicesSub,
  rdServicesTail,
  rdSvcBartending,
  rdSvcBartendingSub,
  rdSvcChildcare,
  rdSvcChildcareSub,
  rdSvcCleaning,
  rdSvcCleaningSub,
  rdSvcCooking,
  rdSvcCookingSub,
  rdSvcGardening,
  rdSvcGardeningSub,
  rdSvcMore,
  rdSvcMoreSub,
  rdSvcMoving,
  rdSvcMovingSub,
  rdSvcRepairs,
  rdSvcRepairsSub,
} from 'Workadabra/translations';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export const ServicesSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string);

  const tiles = [
    { icon: '🧹', name: rdSvcCleaning[language], sub: rdSvcCleaningSub[language], testId: 'service-tile-cleaning' },
    { icon: '👶', name: rdSvcChildcare[language], sub: rdSvcChildcareSub[language], testId: 'service-tile-childcare' },
    { icon: '🍳', name: rdSvcCooking[language], sub: rdSvcCookingSub[language], testId: 'service-tile-cooking' },
    { icon: '🔧', name: rdSvcRepairs[language], sub: rdSvcRepairsSub[language], testId: 'service-tile-repairs' },
    { icon: '🍸', name: rdSvcBartending[language], sub: rdSvcBartendingSub[language], testId: 'service-tile-bartending' },
    { icon: '🌿', name: rdSvcGardening[language], sub: rdSvcGardeningSub[language], testId: 'service-tile-gardening' },
    { icon: '🚚', name: rdSvcMoving[language], sub: rdSvcMovingSub[language], testId: 'service-tile-moving' },
    { icon: '✨', name: rdSvcMore[language], sub: rdSvcMoreSub[language], testId: 'service-tile-more' },
  ];

  return (
    <section className={s.root} data-testid='services-section' id='services'>
      <div className={s.head}>
        <h2 className={s.title} data-testid='services-title'>
          {rdServicesPaint[language]}
          {rdServicesTail[language]}
        </h2>
        <p className={s.sub}>{rdServicesSub[language]}</p>
      </div>
      <div className={s.grid}>
        {tiles.map(tile => (
          <div className={s.tile} data-testid={tile.testId} key={tile.testId}>
            <div className={s.icon}>{tile.icon}</div>
            <p className={s.name}>{tile.name}</p>
            <p className={s.tileSub}>{tile.sub}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
